module.exports = __webpack_public_path__ + "ci_vendor_nagios.49fe5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_nagios.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_nagios.svg
// module chunks = main